import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

//import * as serviceWorker from './serviceWorker';
import { Provider } from "react-redux"
import store from "./store"
import { CookiesProvider } from "react-cookie"
import { HelmetProvider } from "react-helmet-async"
import { BrowserRouter } from "react-router-dom"
import CenterModalProvider from "context/popup/CenterModalProvider"
import ToastProvider from "context/popup/ToastProvider"
import AnimatedWindowProvider from "context/window/AnimatedWindowProvider"

import * as Sentry from "@sentry/react"
import { BrowserTracing } from "@sentry/tracing"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { RecoilRoot } from "recoil"

if (process.env.REACT_APP_ENV !== "dev") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_PROD_DSN,
    integrations: [new BrowserTracing({ tracingOrigins: ["*"] })],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
}
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <RecoilRoot>
      <Provider store={store}>
        <React.StrictMode>
          <CookiesProvider>
            <HelmetProvider>
              <BrowserRouter>
                <AnimatedWindowProvider>
                  <CenterModalProvider>
                    <ToastProvider>
                      <App />
                    </ToastProvider>
                  </CenterModalProvider>
                </AnimatedWindowProvider>
              </BrowserRouter>
            </HelmetProvider>
          </CookiesProvider>
        </React.StrictMode>
      </Provider>
    </RecoilRoot>
  </QueryClientProvider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
